
<template>
  <div class="company_tariffs">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'" v-if="$store.getters.getPermissions.permissionGod === true">
      <div class="select">
        <tree-select
            :options="client_list"
            :multiple="true"
            v-model="filter.client_ids"
            :placeholder="translate('tariffication.client_name')"
            :clearable="true"
            :searchable="true"
        />
      </div>

      <div class="select">
        <tree-select
            :options="status_list"
            :multiple="false"
            v-model="filter.active"
            :placeholder="translate('tariffication.active')"
            :clearable="true"
        />
      </div>

      <div class="select">
        <tree-select
            :options="tariff_services_list"
            :multiple="true"
            v-model="filter.tariff_services"
            :placeholder="translate('tariffication.params_tariff')"
            :clearable="true"
        />
      </div>

      <div class="filter checkbox">
        <div class="info">
          {{ translate('tariffication.with_devices') }}
        </div>
        <label class="switch" @click.prevent="filter.with_devices = !filter.with_devices">
          <input type="checkbox" v-model="filter.with_devices" >
          <span class="slider round"></span>
        </label>
      </div>

      <div class="button">
        <span
            v-if="permission_commerce_god"
            class="btn btn-success btn-fill text-center"
            @click.prevent="start_create_tariff()"
        >
          {{ translate('tariffication.create_tariff') }}
        </span>

      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="Object.keys(summary).length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("tariffication.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer"
                @click="change_filter('tariff_name')"
                :class="{ selected: filter_type === 'tariff_name' }"
                scope="col"
            >
              {{ translate('tariffication.tariff_name') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('tariffication.tariff_client') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('descr')"
                :class="{ selected: filter_type === 'descr' }"
                scope="col"
                v-if="$store.getters.getPermissions.permissionGod === true"
            >
              {{ translate('tariffication.tariff_descr') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('cost')"
                :class="{ selected: filter_type === 'cost' }"
                scope="col"
            >
              {{ translate('tariffication.tariff_cost_with_vat') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
            <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ translate('tariffication.tariff_billing') }}
            </th>
            <th
                class="pointer name"
                @click="change_filter('device_count')"
                :class="{ selected: filter_type === 'device_count' }"
                scope="col"
            >
              {{ translate('tariffication.device_count') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
            <th
                class="pointer name"
                @click="change_filter('simcard_count')"
                :class="{ selected: filter_type === 'simcard_count' }"
                scope="col"
            >
              {{ translate('tariffication.simcard_count') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('date_start')"
                :class="{ selected: filter_type === 'date_start' }"
                scope="col"
            >
              {{ translate('tariffication.date_start') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('date_end')"
                :class="{ selected: filter_type === 'date_end' }"
                scope="col"
            >
              {{ translate('tariffication.date_end') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('ts_end')"
                :class="{ selected: filter_type === 'ts_end' }"
                scope="col"
                v-if="$store.getters.getPermissions.permissionGod === true"
            >
              {{ translate('tariffication.date_close') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
          </tr>
        </thead>
        <tbody>
        <template
            v-for="tariff in comp_tariff_list"
        >
          <router-link
              v-if="$store.getters.getPermissions.permissionGod === true"
              :to="'/tariff/' + tariff.id"
              class="tariff_item__link"
          >
            <TariffListItem
                :tariff="tariff"
                class="tariff_item"
            />
          </router-link>

          <template v-else>
            <TariffListItem
                :tariff="tariff"
                class="tariff_item"
            />
          </template>
        </template>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import CreateTariff from "@/views/Dashboard/General/Tariffication/Tabs/TarrifList/Modal/CreateTariff.vue";
import TariffListItem from "./Item/Index.vue"

export default {
  name: "TariffList",
  components: {
    TariffListItem
  },
  props: ["tariff_filter"],

  data() {
    return {
      load: true,
      filter: {
        client_ids: [],
        active: null,
        with_devices: false,
        tariff_services: []
      },
      check_link: true,
      tariff_list: [],
      summary: {},

      filter_asc: "asc",
      filter_type: "",
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    };
  },
  computed: {
    permission_commerce_god(){
      return this.$store.getters.getPermissions.permissionCommerceGod === true
    },
    comp_tariff_list(){
      let tariff_list = [...this.tariff_list];
      return tariff_list.sort(this.compareNumbers);
    },
    status_list() {
      return [
        { id: 1, label: "Active"},
        { id: 0, label: "Incactive"},
      ];
    },
    client_list() {
      return this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
    },
    tariff_services_list(){
      return this.$store.getters.getTariffServices.map((services) => {
        if (services.type !== null) return { id: services.type, label: services.title }
      }).sort((a, b) => a.id > b.id ? 1 : -1)
    },
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (key === 'tariff_services' || key === 'client_ids'){
          if (this.filter[key].length > 0){
            filter[key] = this.filter[key]
          }
        }else if (key === 'with_devices'){
          filter[key] = this.filter[key] === true ? 1 : 0
        }else{
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })
      return filter;
    },
  },

  created() {
    this.check_query()
  },

  destroyed() {
    this.$modal.hide("tariff_modal");
  },

  watch:{
    sended_filter(){
      if (this.$route.name === 'tariffication_section' && this.$route.params?.tariffication_section === "tariff_list") {
        let string = '?'
        for (let key in this.sended_filter) {
          switch (key) {
            case 'client_ids':
            case 'active':
            case 'tariff_services':
              string += `&${key}=${this.sended_filter[key]}`
              break

            case 'with_devices':
              string += `&${key}=${this.sended_filter[key] ? 1 : 0}`
              break;
          }
        }
        history.pushState(null, null, this.$route.path + string)
        this.change_input()
      }
    }
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_tariffs, 100)
    },
    check_tariff() {
      if (this.$route.params.tariffication_item) {
        this.show_info(Number(this.$route.params.tariffication_item))
        this.check_link = true
      }
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'active':
              this.filter[key] = this.$route.query[key]
              break;

            case 'client_ids':
            case 'tariff_services':
              this.filter[key] = this.$route.query[key].split(',')
              break;

            case 'with_devices':
              this.filter[key] = Boolean(Number(this.$route.query[key]))
              break;
          }
        }
        this.change_input()
      }
    },
    get_tariffs(){
      this.$http.v1.getTariffs(this.sended_filter, (response) => {
        this.tariff_list = response.data.data
        this.summary = response.data.summary

        this.check_tariff();
      })
    },
    start_create_tariff() {
      let t = this.$createElement(CreateTariff, {
        props: {
          clients: this.clients
        },
        on: {
          close: () => {
            this.$modal.hide('create_tariff')
          },
          confirm: () => {
            this.$modal.hide('create_tariff')
            this.get_tariffs()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, { height: 'auto', width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'create_tariff' })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang='scss' scoped>
.company_tariffs {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .select {
      width: 20%;
    }

    .checkbox {
      width: 20%;
      margin: 0;
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .response_table{
    flex: 10;
    padding: 0;

    .link{
      width: 50px;
    }

    th{
      font-size: 12px;
    }
  }

  a{
    &.tariff_item{
      &__link{
        color: #66615b;
      }
    }
  }

  .tariff_item {
    &:hover{
      background-color: #eaeaea;
    }
    .descr{
      text-wrap: nowrap;
      overflow: hidden;
    }
    .end {
      font-weight: bold;
      color: #eb5e28;
    }
    .mdi-pencil{
      font-size: 14px;
      color: #66615b;
    }
  }

  .summary{
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    margin-bottom: 10px;
    p{
      font-size: 12px;
      line-height: 100%;
      margin-bottom: 0;
    }
    span{
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
      br{
        display: none;
      }
    }
  }

  table {
    height: calc(100% - 55px);
    .active_item {
      background-color: #41b88330;
    }
  }
}

@media (max-width: 768px) {
  .company_tariffs {
    .header {
      flex-direction: row;
      flex-wrap: wrap;

      .select {
        width: 100%;
      }

      .checkbox {
        width: 50%;
        margin-bottom: 10px;
        min-width: 100px;
      }

      .button {
        width: 100%;
      }
    }
  }
}
</style>
